import omit from "lodash/omit";
import { createAction } from "@reduxjs/toolkit";
export var ActionTypes;
(function (ActionTypes) {
    ActionTypes["fetch"] = "extraProducts/fetch";
    ActionTypes["fetchSuccess"] = "extraProducts/fetchSuccess";
    ActionTypes["fetchError"] = "extraProducts/fetchError";
    ActionTypes["addProduct"] = "extraProducts/addProduct";
    ActionTypes["setProducts"] = "extraProducts/setProducts";
    ActionTypes["removeProduct"] = "extraProducts/removeProduct";
    ActionTypes["removeAllProducts"] = "extraProducts/removeAllProducts";
    ActionTypes["reset"] = "extraProducts/reset";
    ActionTypes["addPreOptInProduct"] = "extraProducts/addPreOptInProduct";
    ActionTypes["removePreOptInProduct"] = "extraProducts/removePreOptInProduct";
    ActionTypes["resetPreOptIn"] = "extraProducts/resetPreOptIn";
    ActionTypes["resetSelectedExtraProducts"] = "extraProducts/resetSelectedExtraProducts";
    ActionTypes["setPageLoadTime"] = "extraProducts/setPageLoadTime";
    ActionTypes["syncProductsFromExternalStore"] = "extraProducts/syncProductsFromExternalStore";
})(ActionTypes || (ActionTypes = {}));
export const actions = {
    fetch: createAction(ActionTypes.fetch, () => ({
        payload: {}
    })),
    fetchSuccess: createAction(ActionTypes.fetchSuccess, (extraProducts) => ({
        payload: { extraProducts: omit(extraProducts, ["_debug"]) }
    })),
    fetchError: createAction(ActionTypes.fetchError, (error) => ({
        payload: { error }
    })),
    addProduct: createAction(ActionTypes.addProduct, (productType, product) => ({
        payload: { product, productType }
    })),
    setProducts: createAction(ActionTypes.setProducts, (productType, products) => ({
        payload: { products, productType }
    })),
    syncProductsFromExternalStore: createAction(ActionTypes.syncProductsFromExternalStore, (products) => ({
        payload: { products }
    })),
    removeProduct: createAction(ActionTypes.removeProduct, (productType, airProductReference, travellerReference, segmentIndex, legIndex) => ({
        payload: { productType, airProductReference, travellerReference, segmentIndex, legIndex }
    })),
    removeAllProducts: createAction(ActionTypes.removeAllProducts, (productType) => ({
        payload: { productType }
    })),
    addPreOptInProduct: createAction(ActionTypes.addPreOptInProduct, (productType, product) => ({
        payload: { productType, product }
    })),
    removePreOptInProduct: createAction(ActionTypes.removePreOptInProduct, (productType) => ({
        payload: { productType }
    })),
    resetPreOptIn: createAction(ActionTypes.resetPreOptIn, () => ({
        payload: {}
    })),
    reset: createAction(ActionTypes.reset, () => ({
        payload: {}
    })),
    resetSelectedExtraProducts: createAction(ActionTypes.resetSelectedExtraProducts, () => ({
        payload: {}
    })),
    setPageLoadTime: createAction(ActionTypes.setPageLoadTime, (pageLoadTime) => ({
        payload: pageLoadTime
    }))
};
